<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :custom-label="labelSelect"
    :options="options"
    selectLabel=""
    selectedLabel=""
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="false"
    :label="$t('Nome')"
    track-by="id"
    :disabled="false"
    placeholder=""
    :required="isRequired"
  >
  </multiselect>
</template>

<script>
export default {
  props: ['alreadySelected', 'isRequired'],

  data() {
    return {
      selected: null,
      options: [
        { id: null, nome: this.$i18n.t('Todos os tipos') },
        { id: 1, nome: this.$i18n.t('Conta Corrente') },
        { id: 2, nome: this.$i18n.t('Guia Conta Corrente') }
      ]
    };
  },

  methods: {
    onChange(e) {
      this.$emit('tipoSelectChange', e.id);
    },
    labelSelect({ nome }) {
      return `${nome}`;
    }
  },

  created() {
    // Get estados
    if (this.alreadySelected) this.selected = this.alreadySelected;
  }
};
</script>

<style lang="scss" scoped></style>
